import React from 'react';
import {Link} from 'react-router-dom';
import {useBrandKit} from '../../contexts/BrandKitContext';
import BrandKitSummaryCard from './BrandKitSummaryCard';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiPlus}=FiIcons;

export default function AllBrandKits() {
  const {brandKits}=useBrandKit();
  
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold text-gray-800">
          All Brand Kits ({brandKits?.length || 0})
        </h2>
        <Link to="/brand-kit" className="flex items-center px-4 py-2 text-sm font-semibold text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors">
          <SafeIcon icon={FiPlus} className="w-4 h-4 mr-2" />
          Create New Brand Kit
        </Link>
      </div>
      
      {Array.isArray(brandKits) && brandKits.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {brandKits.map(kit=> (
            <BrandKitSummaryCard key={kit.id} brandKit={kit} />
          ))}
        </div>
      ) : (
        <div className="text-center py-12 border-2 border-dashed rounded-lg">
          <p className="text-gray-500">No brand kits found.</p>
          <Link to="/brand-kit" className="text-blue-600 hover:underline mt-2 inline-block">
            Create your first brand kit
          </Link>
        </div>
      )}
    </div>
  );
}